/**
 * Haptic feedback + small mobile UX helpers.
 * navigator.vibrate is silently ignored where unsupported (iOS Safari) — safe to call.
 */

const supportsVibrate = () => typeof navigator !== "undefined" && "vibrate" in navigator;

export function tapLight() {
  if (supportsVibrate()) navigator.vibrate(10);
}

export function tapMedium() {
  if (supportsVibrate()) navigator.vibrate(20);
}

export function tapSuccess() {
  if (supportsVibrate()) navigator.vibrate([15, 40, 15]);
}

export function tapError() {
  if (supportsVibrate()) navigator.vibrate([40, 60, 40]);
}

/** Simple debounce that returns a stable-refless function.
 * Usage: const debounced = useDebounce(); debounced(() => setSearch(q), 250)
 * For most cases in React, prefer useDebouncedValue below.
 */
export function debounce(fn, wait = 200) {
  let t;
  return function (...args) {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}
